import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { ApiError, errorMessage } from "../api/client";

/**
 * D13: a section the role may not open says so in words, instead of an empty table under a technical name
 * («roles», «Нет данных»). The server text already names the missing right and whom to ask.
 */
export function LoadProblem({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const status = error instanceof ApiError ? error.problem.status : 0;
  const title =
    status === 403 ? "Нет доступа к этому разделу" : status === 404 ? "Раздел или запись не найдены" : "Не удалось загрузить данные";
  // BUG-R31-001: a failed load says why and offers to try again; a refusal of rights is not «повторить»
  const retry = onRetry && status !== 403 && status !== 404;
  return (
    <Result
      status={status === 403 ? "403" : status === 404 ? "404" : "warning"}
      title={title}
      subTitle={errorMessage(error)}
      extra={[
        retry ? (
          <Button key="retry" type="primary" onClick={onRetry}>
            Повторить
          </Button>
        ) : null,
        <Link key="home" to="/dashboard">
          <Button type={retry ? "default" : "primary"}>На рабочий стол</Button>
        </Link>,
      ]}
    />
  );
}
